import '../../style/pages/errorPay.css';
import iconFailure from '../../docs/temp/cancel.png';
import { Link } from 'react-router-dom';
import Logo from '../../components/mainPage/Logo';

export default function ErrorPay () {
    return (
        <div className="error-payment-online flex flex-center-center">
            <div className="center">
                <h2 className='title'>Oops! :(</h2>
                <h3 className='digital'>something went error - status code 500</h3>
                <h4>status: online payment error</h4>
                <h5>نعتذر جدا على هذا الخطأ لاكن الأن نواجه بعض المشاكل في الدفع</h5>
                <h6>يرجى الرجوع للدعم الفني لحل المشكلة عن طريق التواصل مع خدمة العملاء</h6>
                <div>
                    <img src={iconFailure} alt='' />
                </div>
                <div className='flex flex-center-center line'>
                    <Link to={'/pos'}>واصل العمل</Link>
                    <button>خدمة العملاء</button>
                </div>
                <div>
                    <p>شكرا لنفهمك و نتعتذر جدا عن هذا الخطأ - زون دائما في خدمتكم</p>
                    <Logo width="20px" flex={true} mode="dark"/>
                </div>
            </div>
        </div>
    )
}